// This may eventually log output to Beam servers, control log verbosity, etc.
// For now it is an alias of the default JS console
export const logger = {
  error: console.error,
  log: console.log,
  warn: console.warn,
  debug: console.debug,
};
